import { readLocalStorageValue } from '@mantine/hooks'

import type { StoreItem } from '@/components/stores/hooks/useStore'

import { getZMPSetting } from '../query/zmp-setting'
import type { ZMPConfig } from './zmp.types'
import { readStoreMenuContext } from '../storefront/store-menu-context'
import {
  getStorefrontStorageKey,
  storefrontConfig,
} from '../storefront/storefront.config'

const readSelectedStore = () => {
  const storeStorage = readLocalStorageValue<{
    state: {
      store: StoreItem | null
    }
  }>({
    key: getStorefrontStorageKey('store-storage'),
  })

  return storeStorage?.state?.store
}

const getRequestedStoreNo = (selectedStore?: StoreItem | null) => {
  if (storefrontConfig.fixedStoreNo) return storefrontConfig.fixedStoreNo

  const searchStoreNo = new URLSearchParams(window.location.search).get('storeNo')

  return searchStoreNo || selectedStore?.storeNo
}

export const getZmpConfig = (): ZMPConfig => {
  const settings = getZMPSetting()
  const selectedStore = readSelectedStore()
  const requestedStoreNo = getRequestedStoreNo(selectedStore)
  const selectedStoreMatchesRequest =
    selectedStore?.storeNo === requestedStoreNo
  const storedMenuContext = readStoreMenuContext(requestedStoreNo)

  return {
    ...settings,
    menuCode:
      (selectedStoreMatchesRequest ? selectedStore?.menu_code : undefined) ||
      storedMenuContext?.menuCode ||
      settings.menuCode,
    storeId: selectedStoreMatchesRequest
      ? selectedStore?.id
      : storedMenuContext?.storeId,
  }
}
